import * as React from 'react';
import { SnackbarContext } from './SnackbarProvider';

export const useSnackbarContext = () => {
  const context = React.useContext(SnackbarContext);
  if (context === undefined) {
    throw new Error('useSnackbarContext must be used within a SnackbarProvider');
  }
  return context;
};

export default useSnackbarContext;
